import adminData from '../data/admin.json';

interface AdminUser {
  email: string;
  password: string;
  role: string;
  token: string;
}

class AdminService {
  private users: AdminUser[];

  constructor() {
    this.users = adminData.users;
  }

  public authenticate(email: string, password: string): string | null {
    const user = this.users.find(
      (u) => u.email === email && u.password === password
    );
    
    return user ? user.token : null;
  }

  public validateToken(token: string): boolean {
    return this.users.some((u) => u.token === token);
  }

  public getUserByToken(token: string): AdminUser | null {
    return this.users.find((u) => u.token === token) || null;
  }
}

export const adminService = new AdminService();